import React from 'react';
import { House, TriangleAlert, RefreshCw } from 'lucide-react';

const FallbackPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-blue-50 to-primary-100 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* Icône d'erreur */}
        <div className="mx-auto w-20 h-20 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-8 border border-neutral-200">
          <TriangleAlert className="w-10 h-10 text-primary-600" />
        </div>

        <h1 className="text-3xl font-bold text-neutral-900 mb-4">Oups !</h1>

        <p className="text-lg text-neutral-600 mb-2">
          Quelque chose s'est mal passé
        </p>

        <p className="text-neutral-600 mb-8 max-w-md mx-auto">
          Notre équipe technique a été notifiée et travaille déjà sur une
          solution.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-button transition-colors duration-200 shadow-button"
          >
            <House className="w-4 h-4" />
            Retour à l'accueil
          </a>

          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white hover:bg-neutral-50 text-neutral-700 font-medium rounded-button border border-neutral-200 transition-colors duration-200 shadow-sm"
          >
            <RefreshCw className="w-4 h-4" />
            Réessayer
          </button>
        </div>
      </div>
    </div>
  );
};

export default FallbackPage;
